import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const supplierSpecialOffersDetailState = (state: AppState) => state.contentManagement.supplierSpecialOffers.detail;

export const supplierSpecialOffersDetailIsValidSelector = createSelector(
    supplierSpecialOffersDetailState,
    state => state.overview.isValid
);
